// extracted by mini-css-extract-plugin
export default {"container":"HV6NF","content":"-hP4k"};